/**
 * Circuit Culture — off-canvas menu drawer
 * Controls the #cc-menu-drawer <dialog> element.
 */

class MenuDrawer {
  #dialog;
  #triggers;
  #closeBtn;

  constructor() {
    this.#dialog = document.getElementById('cc-menu-drawer');
    if (!this.#dialog) return;

    this.#triggers = document.querySelectorAll('.cc-menu-trigger');
    this.#closeBtn = this.#dialog.querySelector('.cc-menu-drawer__close');

    this.#triggers.forEach((t) => t.addEventListener('click', () => this.open()));
    this.#closeBtn?.addEventListener('click', () => this.close());

    // Backdrop click — the dialog fills only the drawer width, so clicks
    // on the right side land on ::backdrop and bubble up as clicks on <dialog>
    this.#dialog.addEventListener('click', (e) => {
      if (e.target === this.#dialog) this.close();
    });

    // ESC key: intercept the native cancel so we can animate out first
    this.#dialog.addEventListener('cancel', (e) => {
      e.preventDefault();
      this.close();
    });
  }

  open() {
    this.#dialog.showModal();
    document.body.style.overflow = 'hidden';
  }

  close() {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced) {
      this.#dialog.close();
      document.body.style.overflow = '';
      return;
    }

    this.#dialog.classList.add('cc-menu-drawer--closing');

    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      this.#dialog.close();
      this.#dialog.classList.remove('cc-menu-drawer--closing');
      document.body.style.overflow = '';
    };

    this.#dialog.addEventListener('transitionend', finish, { once: true });
    // Fallback: if transitionend never fires (e.g. headless, reduced-motion OS pref
    // that didn't match the media query, or element not painted), close after the
    // animation duration plus a small buffer.
    setTimeout(finish, 350);
  }
}

new MenuDrawer();
